module.exports = __webpack_public_path__ + "static/img/index1_1.a170929.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index1_1.png
// module id = 6Wu3
// module chunks = 1